import * as s from "@gromia/components/theme/t.module.css";
import { Hero } from "@gromia/components/ui/HeroFast";
import { Layout } from "@gromia/components/ui/Layout";
import { Text } from "@gromia/components/ui/Text";
import { Seo } from "@gromia/Seo";
import strings from "@gromia/strings/landingSellNew";
import { useString } from "@gromia/utils/useString";
import cx from "classnames";
import * as React from "react";
// import { pipe } from 'fp-ts/lib/function';
// import * as O from 'fp-ts/lib/Option';
import { Agents } from "@gromia/components/landing/Agents";
import { ComparisonTable } from "@gromia/components/landing/ComparisonTable2";
import { Marketing } from "@gromia/components/landing/Marketing";
import { Press } from "@gromia/components/landing/Press";
import { Statistic, Statistics } from "@gromia/components/landing/Statistics";
import { Img, SvgStaticImage } from "@gromia/components/SvgStaticImage";
import { LinkButton } from "@gromia/components/ui/Button";
import { Carousel } from "@gromia/components/ui/Carousel";
import { HeroLandingContent } from "@gromia/components/ui/HeroLandingContent";
import {
  VerticalStep,
  VerticalSteps,
} from "@gromia/components/ui/VerticalIconSteps";
import { useParams } from "@gromia/utils/useParams";
import { StaticImage } from "gatsby-plugin-image";
import { Contacts } from "../_Contacts";
import { Faq } from "./_Faq";
import { Professionals } from "./_Professionals";

function Page(_props: unknown) {
  const p = useParams();
  const { tx, raw } = useString("landingSellNew", strings);

  const cta1 = p.linkWithTracking("/vendita/consulente");
  const cta2 = p.linkWithTracking("/valuta/form");

  const ctaButton = (
    <div className={s.spaceTop2}>
      <LinkButton color="btnCta" to={cta1}>
        {tx("ctaHero")}
      </LinkButton>
    </div>
  );

  return (
    <React.Fragment>
      <Seo title={raw("seoTitle")} description={raw("seoDescription")} />
      <Hero
        image={() => (
          <StaticImage
            src="./images/hero.jpg"
            alt=""
            className={Hero.imageClass}
          />
        )}
      >
        <HeroLandingContent
          title1={tx("title1")}
          title2={tx("title2")}
          cta={tx("ctaHero")}
          ctaHref={cta1}
          cta2={tx("ctaHero2")}
          cta2Href={cta2}
          layout="75"
        />
      </Hero>
      <section className={cx(s.bgWhite, s.space2, s.textCenter)}>
        <Press />
      </section>
      <section className={cx(s.bgLight2, s.space2, s.textCenter)}>
        <div className={cx(s.container)}>
          <Text tag="p" s="pill">
            {tx("whyPill")}
          </Text>
          <Text tag="h2" s="title">
            {tx("whyTitle")}
          </Text>
          <Text tag="p" s="p">
            {tx("whyText")}
          </Text>
          <div className={cx(s.spaceTop1, s.maxWidth800, s.mxAuto)}>
            <Carousel
              options={{
                arrows: false,
                perPageXl: 2,
                perPageLg: 2,
                perPageMd: 2,
                perPageSm: 1,
                perPageXs: 1,
              }}
            >
              <MarketingCard
                l={require("./images/finance-rafiki-3.svg")}
                r={tx("why1")}
              />
              <MarketingCard
                l={require("./images/service-24-7-rafiki.svg")}
                r={tx("why2")}
              />
            </Carousel>
          </div>
        </div>
      </section>
      <section className={cx(s.bgWhite, s.space2, s.textCenter)}>
        <div className={cx(s.container)}>
          <Text tag="p" s="pill">
            {tx("howPill")}
          </Text>

          <div>
            <Text tag="h2" s="title">
              {tx("howTitle")}
            </Text>
            <Text tag="p" s="titleSmall" short>
              {tx("howText")}
            </Text>
            <SvgStaticImage
              src={require("./images/report-rafiki.svg")}
              alt=""
              maxHeight={384}
            />
          </div>

          <div className={cx(s.spaceTop2)}>
            <Text tag="h2" s="title">
              {tx("howTitle2")}
            </Text>
            <Text tag="p" s="titleSmall" short>
              {tx("howText2")}
            </Text>
            <SvgStaticImage
              src={require("./images/fill-out-rafiki.svg")}
              alt=""
              maxHeight={384}
            />
          </div>
          <div className={cx(s.spaceTop2)}>
            <Text tag="h2" s="title">
              {tx("howTitle3")}
            </Text>
            <Text tag="p" s="titleSmall" short>
              {tx("howText3")}
            </Text>
            <SvgStaticImage
              src={require("./images/design-stats-rafiki.svg")}
              alt=""
              maxHeight={384}
            />
          </div>
          <div className={cx(s.spaceTop2)}>
            <Text tag="h2" s="title">
              {tx("howTitle4")}
            </Text>
            <Text tag="p" s="titleSmall" short>
              {tx("howText4")}
            </Text>
            <SvgStaticImage
              src={require("./images/social-tree-rafiki.svg")}
              alt=""
              maxHeight={384}
            />
          </div>
          {ctaButton}
        </div>
      </section>
      <Marketing />
      <section className={cx(s.bgWhite, s.space2, s.textCenter)}>
        <div className={cx(s.container)}>
          <Text tag="p" s="pill">
            {tx("howPill")}
          </Text>

          <div>
            <Text tag="h2" s="title">
              {tx("howTitle5")}
            </Text>
            <Text tag="p" s="titleSmall" short>
              {tx("howText5")}
            </Text>
            <SvgStaticImage
              src={require("./images/data-extraction-rafiki.svg")}
              alt=""
              maxHeight={384}
            />
          </div>
        </div>
      </section>
      <section className={cx(s.bgPrimaryDarker, s.textCenter, s.spaceTop2)}>
        <div className={cx(s.container)}>
          <Text tag="p" s="pill" inverted>
            {tx("statsPill")}
          </Text>
          <Text tag="h2" s="title" inverted>
            {tx("statsTitle")}
          </Text>
        </div>
        <div className={cx(s.maxWidth800, s.mxAuto)}>
          <Statistics>
            <Statistic stat={tx("stat1")} sub={tx("stat1Sub")} />
            <Statistic stat={tx("stat2")} sub={tx("stat2Sub")} />
            <Statistic stat={tx("stat3")} sub={tx("stat3Sub")} />
          </Statistics>
        </div>
      </section>
      <section className={cx(s.bgWhite, s.space2, s.textCenter)}>
        <div className={cx(s.container)}>
          <Text tag="p" s="pill">
            {tx("stepsPill")}
          </Text>
          <Text tag="h2" s="title">
            {tx("stepsTitle")}
          </Text>
          <div className={cx(s.row, s.spaceTop2)}>
            <div className={cx(s.col, s.col12, s.colLg6)}>
              <VerticalSteps>
                <VerticalStep
                  icon={require("./images/step1.svg")}
                  title={tx("steps1Title")}
                  text={tx("steps1Text")}
                />
                <VerticalStep
                  icon={require("./images/step2.svg")}
                  title={tx("steps2Title")}
                  text={tx("steps2Text")}
                />
                <VerticalStep
                  icon={require("./images/step3.svg")}
                  title={tx("steps3Title")}
                  text={tx("steps3Text")}
                />
                <VerticalStep
                  icon={require("./images/step4.svg")}
                  title={tx("steps4Title")}
                  text={tx("steps4Text")}
                />
                <VerticalStep
                  icon={require("./images/step5.svg")}
                  title={tx("steps5Title")}
                  text={tx("steps5Text")}
                />
              </VerticalSteps>
            </div>
            <div className={cx(s.col, s.colLg6, s.dNone, s.dLgBlock)}>
              <div className={cx(s.dFlex, s.h100, s.alignItemsCenter)}>
                <SvgStaticImage
                  src={require("./images/realtor-rafiki.svg")}
                  alt=""
                />
              </div>
            </div>
          </div>
          {ctaButton}
        </div>
      </section>
      <StaticImage src="./images/slide.png" alt="" layout="fullWidth" />
      <section className={cx(s.bgLight2, s.space2, s.textCenter)}>
        <div className={cx(s.container)}>
          <Text tag="p" s="pill">
            {tx("comparisonPill")}
          </Text>
          <Text tag="h2" s="title">
            {tx("comparisonTitle")}
          </Text>
          <Text tag="p" s="p">
            {tx("comparisonText")}
          </Text>
          <div className={cx(s.row)}>
            <div className={cx(s.col, s.col12, s.colLg10, s.offsetLg1)}>
              <ComparisonTable>
                <ComparisonTable.Item
                  labl={tx("comparison11")}
                  lval={tx("comparison12")}
                  rval={tx("comparison13")}
                />
                <ComparisonTable.Item
                  labl={tx("comparison21")}
                  lval={tx("comparison22")}
                  rval={tx("comparison23")}
                />
                <ComparisonTable.Item
                  labl={tx("comparison31")}
                  lval={tx("comparison32")}
                  rval={tx("comparison33")}
                />
                <ComparisonTable.Item
                  labl={tx("comparison41")}
                  lval={tx("comparison42")}
                  rval={tx("comparison43")}
                />
                <ComparisonTable.Item
                  labl={tx("comparison61")}
                  lval={tx("comparison62")}
                  rval={tx("comparison63")}
                />
              </ComparisonTable>
            </div>
          </div>
          {ctaButton}
        </div>
      </section>
      <Professionals className={s.bgLight1} />
      <Agents ctaButton={ctaButton} className={s.bgLight2} />
      <Faq />
      <Contacts />
    </React.Fragment>
  );
}

export function MarketingCard(props: { l: Img; r: React.ReactNode }) {
  return (
    <Carousel.Card className={cx(s.alignItemsCenter)}>
      <SvgStaticImage src={props.l} alt="" />
      <span className={cx(s.fontSizeLarge2, s.fontWeightBold, s.textLeft)}>
        {props.r}
      </span>
    </Carousel.Card>
  );
}

export default (props: any) => (
  <Layout>
    <Page {...props} />
  </Layout>
);
